export default {
  // 新订单列表
  all: '全部',
  toPay: '待支付',
  toDispatch: '待发货',
  inTransit: '在途',
  completed: '已完成',
  canceled: '已取消',
  rejected: '已拒收',
  inTransitStatus: '在途状态',
  toPickupByLogistics: '待物流收件',
  pickedUpByLogistics: '物流已收件',
  orderTime: '下单时间',
  paymentTime: '支付时间',
  dispatchTime: '发货时间',
  completeTime: '完成时间',
  noLimit: '不限',
  today: '今天',
  yesterday: '昨天',
  recent7Days: '最近7天',
  recent30Days: '最近30天',
  recent90Days: '最近90天',
  orderNumber: '订单编号',
  billNumber: '支付批次号',
  buyerID: '买家编号',
  skuID: 'SKU编号',
  listingID: 'Listing编号',
  vendorProductID: '供应商货号',
  fulfillType: '履约类型',
  productName: '商品名称',
  paymentType: '支付类型',
  fullyPrepaid: '全额在线支付',
  partialPrepaid: '部分在线支付',
  payOnDelivery: '货到付款',
  paymentStatus: '支付状态',
  unpaid: '未支付',
  paid: '已支付',
  resetFilter: '重置各筛选项',
  export: '导出订单',
  fold: '折叠',
  more: '更多',
  batchOperation: '批量操作',
  dispatch: '发货',
  printWaybill: '打印运单',
  orderAmount: '订单金额',
  skus: '商品种数',
  qty: '件数',
  operation: '操作',
  product: '商品',
  variant: '规格',
  unitPrice: '单价',
  detail: '详情',
  printList: '打印清单',
  trackOrder: '跟踪订单',
  deleted: '已删除',
  logisticsInformation: '物流信息',
  trackNo: '运单编号',
  close: '关闭',
  deliveryAddress: '配送地址',
  parcel: '包裹',
  startDate: '开始日期',
  endDate: '结束日期',
  search: '搜索',
  printListTip: '之前已经打印过清单。 您确定再次打印吗？',
  printPackingList: '打印清单',
  registerLog: '无法进行批量发货操作。请先注册或登录平台物流帐户。',
  supplementRequired: '无法进行批量发货操作。请在相关的商品的详情编辑中补充必要的海关信息。',
  declaredValue: '无法进行批量发货操作。相关订单的中商品的申报货值超过上限。',
  goToSettings: '去设置',
  goToSupplement: '去补充',
  goAdjust: '去调整',
  cancel: '取消',
  dispatchingPanel: '批量发货面板',
  doNotSupportPackage: '批量发货功能不支持订单内的集包处理',
  logisticsMethod: '物流平台',
  platformLogistics: '平台物流配送',
  fulfillBySeller: '卖家自配送',
  usePlatformPacking: '代打包服务',
  yes: '是',
  no: '否',
  domesticCourier: '国内快递公司',
  courierWaybill: '快递单号',
  remark: '备注信息',
  batchApply: '批量应用',
  orderInformation: '订单信息',
  platformWaybill: '运单编号',
  kiliExpress: '平台物流',
  firstLegService: '无法进行批量发货操作。您的物流帐户头程余额不足。',
  topUp: '去充值',
  pleaseChoose: '请选择',
  pleaseEnter: '请输入',
  inDispatch: '发货中',
  failedToDispatch: '发货失败',
  dispatched: '已发货',
  orderStatus: '订单状态',
  dispatchStatus: '发货状态',
  yourOrderDispatchClose: `您的订单增在批量发货中，关闭弹窗将终止此次发货。已经成功发货的不会回撤。`,
  continueDispatching: '不关闭弹窗，继续发货',
  terminateDispatching: '终止发货',
  dispatchCompleted: '发货完成 ({0}成功, {1}失败)',
  orderNoSign: '订单编号'
}
